import { createAction } from '@reduxjs/toolkit';

import type {
	PendingFriendRequestsResponse,
	PlayerFriendshipStatus,
	PlayersDirectoryFilter,
	PlayersDirectoryProfileFilter,
	PlayersDirectoryResponse,
} from '../../services/api';

/** The Social screen's player grid: one filter + search at a time, paged on scroll. */
export const directoryRequest = createAction<{
	filter: PlayersDirectoryFilter;
	query: string;
	profile?: PlayersDirectoryProfileFilter;
	append?: boolean;
}>('friends/directory/request');
export const directorySuccess = createAction<{
	response: PlayersDirectoryResponse;
	append: boolean;
}>('friends/directory/success');
export const directoryFailure = createAction<string>('friends/directory/failure');

/** The friends list of the profile modal's Friends tab. */
export const friendsListRequest = createAction<{ query: string }>('friends/list/request');
export const friendsListSuccess = createAction<{
	response: PlayersDirectoryResponse;
	query: string;
}>('friends/list/success');
export const friendsListFailure = createAction<string>('friends/list/failure');

export const pendingRequestsRequest = createAction('friends/pending/request');
export const pendingRequestsSuccess =
	createAction<PendingFriendRequestsResponse>('friends/pending/success');
export const pendingRequestsFailure = createAction<string>('friends/pending/failure');

export const friendRequestSend = createAction<{ playerId: string }>('friends/send/request');
export const friendRequestRespond = createAction<{
	playerId: string;
	requestId: string;
	accept: boolean;
}>('friends/respond/request');
export const friendRemove = createAction<{ playerId: string }>('friends/remove/request');

/** One of the three actions above settled: the player's relationship is now `status`. */
export const friendActionSuccess = createAction<{
	playerId: string;
	status: PlayerFriendshipStatus;
	friendRequestId: string | null;
}>('friends/action/success');
export const friendActionFailure = createAction<{ playerId: string; message: string }>(
	'friends/action/failure',
);
